export default class GrupoDeTarefas {
  constructor() {
    this.nome = ""
    this.tarefasId = []
    this.regimeId = ""
    this.dataVigencia = null
    this.empresasIds = []
  }
}
